import React from 'react';
import MobileBanner from "@/page-components/verify/Banner/mobile_banner";
import PCBanner from "@/page-components/verify/Banner/pc_banner";
import MobileComponentWrapper from "@/components/MobileComponentWrapper";
import PcComponentWrapper from "@/components/PcComponentWrapper";
import styles from './styles.module.less';

type TBanner = {
}

const VerifyBanner:React.FC<TBanner> = () => {
  return (
    <div className={styles.banner_wrapper}>
      <MobileComponentWrapper>
        <MobileBanner/>
      </MobileComponentWrapper>
      <PcComponentWrapper>
        <PCBanner/>
      </PcComponentWrapper>
    </div>
  )
}
export default VerifyBanner;
